import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { TextLine } from "@ltypes/scene";
import Product, { ProductModelType } from "@ltypes/product";
import TextField from "@components/forms/TextField/TextField";
import Slider from "@components/forms/Slider/Slider";
import Color from "@components/forms/Color/Color";
import Select from "@components/forms/Select/Select";
import { MdClose } from "react-icons/md";
import './TextFlashLine.scss';

type TextFlashLineProps = {
    index: number,
    line: TextLine,
    onChange: (line: TextLine) => void,
    onDelete: () => void,
};

function TextFlashLine({ index, line, onChange, onDelete }: TextFlashLineProps) {
    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);
    const isLegacy = product.model.type === ProductModelType.LEGACY;

    const handleChangeText = (value: string) => {
        if (value === '' || /^[\x20-\x7E]+$/.test(value)) {
            onChange({ ...line, text: value });
        }
    };

    return (
        <div className="textflash-line">
            <div className="textflash-line-top">
                <span className="textflash-line-badge">{index}</span>
                <div className="textflash-line-text">
                    <TextField
                        value={line.text}
                        placeholder={t('page.scenes.data.your_text_placeholder')}
                        onChange={handleChangeText}
                    />
                </div>
                <button className="textflash-line-delete" onClick={onDelete}>
                    <MdClose />
                </button>
            </div>
            <div className="textflash-line-controls">
                <div className="textflash-line-color">
                    <Color label={t('page.scenes.data.text_color')} value={line.textcolor} onChange={(v) => onChange({ ...line, textcolor: v })} />
                </div>
                <div className="textflash-line-size">
                    <Select
                        label={t('page.scenes.data.text_size')}
                        value={line.textsize}
                        items={isLegacy
                            ? [{ label: '0', value: 0 }, { label: '1', value: 1 }]
                            : new Array(7).fill(0).map((_, i) => ({ label: `${i + 1}`, value: i + 1 }))
                        }
                        onChange={(v) => onChange({ ...line, textsize: Number(v) as TextLine['textsize'] })}
                    />
                </div>
                <div className="textflash-line-speed">
                    <Slider label={t('page.scenes.data.speed')} value={line.speed} onChange={(v) => onChange({ ...line, speed: v })} />
                </div>
                {line.speed === 0 && (
                    <div className="textflash-line-align">
                        <Select
                            label={t('page.scenes.data.text_position')}
                            value={line.textalignment}
                            items={[
                                { label: t('text.left'), value: '0' },
                                { label: t('text.center'), value: '1' },
                                { label: t('text.right'), value: '2' },
                            ]}
                            onChange={(v) => onChange({ ...line, textalignment: Number(v) as TextLine['textalignment'] })}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default TextFlashLine;
